import React from 'react';
import { Image } from 'react-bootstrap';

const NotFound: React.FC = () => {
  return (
    <div className="blank-container">
      <div className="blank-content">
        <div className="blank-form-container">
          <div className="text-center mb-4">
            <Image 
              src="/logo.svg" 
              alt="ESF Logo" 
              className="logo-image" 
            />
            <h4>ページが見つかりません。</h4>
          </div>

          <div className="text-center">
            <p>
              お探しのページは存在しないか、URLが間違っている可能性があります。<br />
              正しいURLでアクセスしているか確認してください。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
